import createDeepClone from 'rfdc';

export const deepClone = createDeepClone();
